import type { GridRenderHeaderFilterProps } from "@mui/x-data-grid-premium";
import { DataGridTextHeaderFilterImpl } from "src/components/DataGrid/DataGridTextHeaderFilterImpl.tsx";

export const DataGridTextHeaderFilter = (
  props: GridRenderHeaderFilterProps,
) => {
  // this wrapper exists only to fix hot reloading in this component
  return <DataGridTextHeaderFilterImpl {...props} />;
};
